import { SeoMetaData } from '@cms-max/cms-browser-api-client'
import { Component } from '@cms-max/medicare-api-sdk'

export const accountSettingsSeoMetaData: SeoMetaData[] = [
  {
    path: '/account-settings',
    seo: {
      en: {
        title: 'My account settings | Medicare',
        description: ''
      },
      es: {
        title: 'Configuración de mi cuenta | Medicare',
        description: ''
      }
    }
  },
  {
    path: '/account-settings/get-my-medicare-card',
    seo: {
      en: {
        title: 'Get my Medicare card | Medicare',
        description: ''
      },
      es: {
        title: 'Conseguir mi tarjeta médica | Medicare',
        description: ''
      }
    }
  },
  {
    path: '/account-settings/delete-account',
    seo: {
      en: {
        title: 'Delete account | Medicare',
        description: ''
      },
      es: {
        title: 'SPA_Delete account | Medicare',
        description: ''
      }
    }
  }
].map(seoMetaData => ({
  ...seoMetaData,
  component: Component.AccountSettings
}))
